import React, { useEffect, useState } from 'react';
import '../scss/Modal.scss';
import QuoteForm from './QuoteForm';

const Modal = ({ isOpen, onClose, title, children, tyreData, remainingDescription }) => {
  const [message, setMessage] = useState(null); // { type: 'success' | 'error', text: string }
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Réinitialiser le message quand la modal s'ouvre
  useEffect(() => {
    if (isOpen) {
      setMessage(null);
    }
  }, [isOpen]);

  const handleQuoteSubmit = async (formData) => {
    setIsSubmitting(true);
    setMessage(null);

    try {
      // Récupérer les variables injectées par WordPress
      const { apiUrl, apiKey, adherentCode } = window.axTyresCatalog || {};
      
      if (!apiUrl || !apiKey) {
        throw new Error('Configuration API manquante');
      }

      // Préparer les données au format de l'API extranet
      const tyreDetails = tyreData ? `${tyreData.brand} ${tyreData.profile?.name} ${tyreData.width}/${tyreData.height}R${tyreData.radius}` : '';
      
      const quoteData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        company: formData.company || '',
        email: formData.email,
        phone: formData.phone,
        tyre: tyreDetails,
        tyreEan: tyreData?.eanCode || '',
        details: tyreDetails,
        quantity: parseInt(formData.quantity) || 1,
        price: tyreData?.price || 0,
        quoteBannerUrl: '',
        quoteBannerImage: '',
        link: window.location.href,
        adherentCode: adherentCode || '',
        wpId: '',
        address: formData.address,
        zipCode: formData.postalCode,
        city: formData.city
      };

      // Envoyer directement à l'API extranet
      const response = await fetch(`${apiUrl}/quotes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-KEY': apiKey
        },
        body: JSON.stringify(quoteData)
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      await response.json();

      // Gérer l'inscription à la newsletter si demandée
      if (formData.newsletter && formData.email) {
        // Appel séparé pour la newsletter via WordPress
        fetch(window.ajaxurl || '/wp-admin/admin-ajax.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            action: 'ax_newsletter_send_email',
            email: formData.email
          }).toString()
        }).catch(err => console.warn('Erreur newsletter:', err));
      }

      setMessage({
        type: 'success',
        text: 'Votre demande de devis a été envoyée avec succès ! Nous vous contacterons dans les plus brefs délais.'
      });

      // Fermer la modal après 3 secondes
      setTimeout(() => {
        onClose();
      }, 3000);
    } catch (error) {
      console.error('Erreur lors de l\'envoi du devis:', error);
      setMessage({
        type: 'error',
        text: 'Une erreur est survenue lors de l\'envoi du devis. Veuillez réessayer.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-body">
		  <button className="modal-close" onClick={onClose}>&times;</button>
          
          {/* Affichage du message de succès ou d'erreur */}
          {message && (
            <div className={`modal-message modal-message--${message.type}`}>
              <div className="modal-message__icon">
                {message.type === 'success' ? '✓' : '✕'}
              </div>
              <div className="modal-message__text">{message.text}</div>
            </div>
          )}

          {children}
          <QuoteForm 
            onSubmit={handleQuoteSubmit} 
            tyreData={tyreData} 
            isSubmitting={isSubmitting}
            disabled={message?.type === 'success'}
          />
		  <div className="tyre-remaining-description" dangerouslySetInnerHTML={{ __html: remainingDescription }} />
        </div>
      </div>
    </div>
  );
};

export default Modal; 